'use strict';

// ----------------------------------------
// Imports
// ----------------------------------------

import 'select2';
import 'jquery-validation';

// ----------------------------------------
// Public
// ----------------------------------------

function initSelect () {
	$('.select2').each(function (index) {
		var $this = $(this);

		$this.select2({
			minimumResultsForSearch: Infinity,
			dropdownParent: $this.closest('.select2-wrap'),
			placeholder: $this.data('placeholder'),
			width: 'resolve'
		});

		$this.on('select2:select', function () {
			var $form = $this.closest('.js-form');

			if ($form.length) {
				$form.validate().element($this);
			}
		});
	});
}

// ----------------------------------------
// Exports
// ----------------------------------------

export {initSelect};



// WEBPACK FOOTER //
// ./src/js/_modules/select2.js